function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { canUseDOM } from "../../../shared/utils/canUseDOM.js";
/**
 * Helper method to split URL hash into useful pieces
 */

var getParsedURL = function getParsedURL() {
  var hash = window.location.hash.substr(1),
      tmp = hash.split("-"),
      index = tmp.length > 1 && /^\+?\d+$/.test(tmp[tmp.length - 1]) ? parseInt(tmp.pop(-1), 10) || null : null,
      slug = tmp.join("-");
  return {
    hash: hash,
    slug: slug,
    index: index
  };
};

export var Hash = /*#__PURE__*/function () {
  function Hash(fancybox) {
    _classCallCheck(this, Hash);

    this.fancybox = fancybox;

    for (var _i = 0, _arr = ["onChange", "onClosing"]; _i < _arr.length; _i++) {
      var methodName = _arr[_i];
      this[methodName] = this[methodName].bind(this);
    }

    this.events = {
      initCarousel: this.onChange,
      "Carousel.change": this.onChange,
      closing: this.onClosing
    };
    this.hasCreatedHistory = false;
    this.origHash = "";
    this.timer = null;
  }
  /**
   * Process `Carousel.ready` and `Carousel.change` events to update URL hash
   * @param {Object} fancybox
   * @param {Object} carousel
   */


  _createClass(Hash, [{
    key: "onChange",
    value: function onChange() {
      var _this = this;

      var fancybox = this.fancybox;
      var carousel = fancybox.Carousel;

      if (this.timer) {
        clearTimeout(this.timer);
      }

      var firstRun = carousel.prevPage === null;
      var slide = fancybox.getSlide();
      var dataset = slide.$trigger && slide.$trigger.dataset;
      var currentHash = window.location.hash.substr(1);
      var newHash = false;

      if (slide.slug) {
        newHash = slide.slug;
      } else {
        var dataAttribute = dataset && dataset.fancybox;

        if (dataAttribute && dataAttribute.length && dataAttribute !== "true") {
          newHash = dataAttribute + (carousel.slides.length > 1 ? "-" + (slide.index + 1) : "");
        }
      }

      if (firstRun) {
        this.origHash = currentHash !== newHash ? this.origHash : "";
      }

      if (newHash && currentHash !== newHash) {
        this.timer = setTimeout(function () {
          try {
            window.history[firstRun ? "pushState" : "replaceState"]({}, document.title, window.location.pathname + window.location.search + "#" + newHash);

            if (firstRun) {
              _this.hasCreatedHistory = true;
            }
          } catch (e) {}
        }, 300);
      }
    }
    /**
     * Process `closing` event to clean up
     */

  }, {
    key: "onClosing",
    value: function onClosing() {
      if (this.timer) {
        clearTimeout(this.timer);
      } // Skip if closing is triggered by pressing  browser back button or by changing hash manually


      if (this.hasSilentClose === true) {
        return;
      } // Simply make browser to move back one page in the session history,
      // if new history entry is successfully created


      if (!this.hasCreatedHistory) {
        try {
          window.history.replaceState({}, document.title, window.location.pathname + window.location.search + (this.origHash ? "#" + this.origHash : ""));
          return;
        } catch (e) {}
      }

      window.history.back();
    }
  }, {
    key: "attach",
    value: function attach(fancybox) {
      fancybox.on(this.events);
    }
  }, {
    key: "detach",
    value: function detach(fancybox) {
      fancybox.off(this.events);
    }
    /**
     * Start fancybox from current URL hash,
     * this will be called on page load OR/AND after changing URL hash
     * @param {Class} Fancybox
     */

  }], [{
    key: "startFromUrl",
    value: function startFromUrl() {
      if (!Hash.Fancybox || Hash.Fancybox.getInstance()) {
        return;
      }

      var _getParsedURL = getParsedURL(),
          hash = _getParsedURL.hash,
          slug = _getParsedURL.slug,
          index = _getParsedURL.index;

      if (!slug) {
        return;
      } // Support custom slug
      // ===


      var selectedElem = document.querySelector("[data-slug=\"".concat(hash, "\"]"));

      if (selectedElem) {
        selectedElem.dispatchEvent(new CustomEvent("click", {
          bubbles: true,
          cancelable: true
        }));
      }

      if (Hash.Fancybox.getInstance()) {
        return;
      } // If elements are not found by custom slug, Use URL hash value as group name
      // ===


      var groupElems = document.querySelectorAll("[data-fancybox=\"".concat(slug, "\"]"));

      if (!groupElems.length) {
        return;
      }

      if (index === null && groupElems.length === 1) {
        selectedElem = groupElems[0];
      } else if (index) {
        selectedElem = groupElems[index - 1];
      }

      if (selectedElem) {
        selectedElem.dispatchEvent(new CustomEvent("click", {
          bubbles: true,
          cancelable: true
        }));
      }
    }
    /**
     * Handle `hash` change, change gallery item to current index or start/close current instance
     */

  }, {
    key: "onHashChange",
    value: function onHashChange() {
      var _getParsedURL2 = getParsedURL(),
          slug = _getParsedURL2.slug,
          index = _getParsedURL2.index;

      var instance = Hash.Fancybox.getInstance();

      if (instance) {
        // Look if this is inside currently active gallery
        if (slug) {
          var carousel = instance.Carousel;
          /**
           * Check if URL hash matches `data-slug` value of active element
           */

          var _iterator = _createForOfIteratorHelper(carousel.slides),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var _slide = _step.value;

              if (_slide.slug && _slide.slug === slug) {
                return carousel.slideTo(_slide.index);
              }
            }
            /**
             * Check if URL hash matches `data-fancybox` value of active element
             */

          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }

          var slide = instance.getSlide();
          var dataset = slide.$trigger && slide.$trigger.dataset;

          if (dataset && dataset.fancybox === slug) {
            return carousel.slideTo(index - 1);
          }
        }
        /**
         * Close if no matching element found
         */


        instance.plugins.Hash.hasSilentClose = true;
        instance.close();
      }
      /**
       * Attempt to start
       */


      Hash.startFromUrl();
    }
    /**
     * Add event bindings that will start new Fancybox instance based in the current URL
     */

  }, {
    key: "create",
    value: function create(Fancybox) {
      Hash.Fancybox = Fancybox;

      function proceed() {
        window.addEventListener("hashchange", Hash.onHashChange, false);
        Hash.startFromUrl();
      }

      if (canUseDOM) {
        window.requestAnimationFrame(function () {
          if (/complete|interactive|loaded/.test(document.readyState)) {
            proceed();
          } else {
            document.addEventListener("DOMContentLoaded", proceed);
          }
        });
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      window.removeEventListener("hashchange", Hash.onHashChange, false);
    }
  }]);

  return Hash;
}();